import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'
import localstore from 'store'
import { createRouterLayout } from 'vue-router-layout'
import { routes } from 'vue-router/auto-routes'
import store from '@/store'
import TokenizedAccess from '@/components/tokenizedAccess/_token.vue'
import EquipmentUUID from '@/pages/equipment/_uuid.vue'
import qs from 'qs'

const RouterLayout = createRouterLayout((layout) => {
  console.log('RouterLayout called with layout:', layout)
  if (layout === 'outlook') {
    console.log('Loading outlook layout')
    return import('@/layouts/outlook.vue')
  }
  if (layout === 'default') {
    return import('./layouts/default.vue')
  }
  return import('@/layouts/clean.vue')
})

// Use memory history for Outlook dialog context (Office API limitations)
// Use web history for normal web context
const isInOfficeDialog = () => {
  try {
    return typeof Office !== 'undefined' && Office.context && Office.context.ui
  } catch {
    return false
  }
}

const historyMode = isInOfficeDialog() ? createMemoryHistory() : createWebHistory()

const router = createRouter({
  history: historyMode,
  saveScrollPosition: true,
  routes: [
    {
      name: 'tokenized-access',
      path: '/tokenized-access/:token?',
      component: TokenizedAccess
    },
    {
      name: 'equipment-uuid',
      path: '/equipment-uuid/:uuid?',
      component: EquipmentUUID
    },
    {
      path: '/',
      component: RouterLayout,
      children: routes
    },
    {
      path: '/:pathMatch(.*)*',
      component: RouterLayout,
      children: [
        {
          name: 'page-404',
          path: '',
          component: () => import('@/components/NotFound.vue')
        }
      ]
    }
  ],
  // set custom query resolver
  parseQuery(query) {
    return qs.parse(query)
  },
  stringifyQuery(query) {
    var result = qs.stringify(query)
    return result
    // https://router.vuejs.org/api/interfaces/RouterOptions.html#stringifyQuery- Custom implementation to stringify a query object. Should not prepend a leading ?
    // return result ? '?' + result : ''
  }
})

router.beforeEach((to, from, next) => {
  if (store?.getters['unsavedChanges']) {
    let options = {
      title: 'Unsaved changes',
      text: `There are unsaved changes. Are you sure you want to navigate away?`,
      showCancelButton: false,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#33d',
      confirmButtonText: 'Yes, leave',
      cancelButtonText: 'Stay',
      buttonsStyling: true
    }
    const app = window.getAppInstance ? window.getAppInstance() : null
    if (app) {
      app.config.globalProperties.$alerts
        .$confirm(options.text, options.title, 'warning', options)
        .then((result) => {
          store.dispatch('setUnsavedChanges', false)
          handleRouteGuards(to, from, next)
        })
        .catch((error) => {
          // canceled, stay on page
          return next(false)
        })
    }
    // confirmed reset unsaved changes and continue
  } else {
    handleRouteGuards(to, from, next)
  }
})

const handleRouteGuards = (to, from, next) => {
  const user = localstore.get('ews_user', {})
  const current = localstore.get('ews_current_station', {})

  // Skip guards for outlook-addin routes (they manage their own auth/station)
  if (to.path.startsWith('/outlook-addin')) {
    next()
    return
  }

  const isAdminUser = store?.getters?.isAdminUser || user.access?.admin

  if (to.matched.some((record) => record.path == '/stagehand') && user.access && !user.access.stagehand.includes(current.station)) {
    next('/')
  } else if (to.matched.some((record) => record.path == '/admin') && !isAdminUser) {
    next('/')
  } else if (to.matched.some((record) => record.name !== 'tokenized-access') && current.station && !to.query?.station) {
    // make sure station query parameter persists route changes
    try {
      let updatedNext = {
        ...to,
        query: {
          ...to.query,
          station: current.station
        }
      }
      next(updatedNext)
    } catch (error) {
      // canceled, stay on page
      return next(false)
    }
  } else {
    next()
  }
}

export default router
